<template>
  <div
    class="footer-section"
    :class="{ 'accent': accent }"
  >
    <div class="md-layout md-alignment-left-center">
      <div class="md-layout-item md-small-size-30 md-xsmall-size-100 md-layout">
        <div style="width:120px; color: #ffffff; margin-left:30px;">
          Kampala Biennale 2020 is co-funded by
        </div>
        <div class="event-sponsor">
          <a
            href="https://europa.eu/european-union/index_en"
            target="_blank"
          >
            <img
              alt="kab logo"
              width="70"
              height="48"
              :src="require('@/assets/EUflag.png')"
            >
          </a>
        </div>
        <div class="event-sponsor">
          <a
            href="https://prohelvetia.org.za/en/"
            target="_blank"
          >
            <img
              alt="kab logo"
              width="180"
              height="48"
              :src="require('@/assets/swiss-1.jpg')"
            >
          </a> 
        </div>
      </div>
      <div class="md-layout-item md-small-size-70 md-xsmall-size-100 footer-container">
        <div class="md-layout md-alignment-top-right">
          <div class="kabs-terms">
            The Kampala Art Biennale is produced by
            <a
              href="http://kart.kampalabiennale.org/"
              target="_blank"
            >Kampala Arts Trust</a>&nbsp; & &nbsp; <a
              href="https://www.afriartgallery.org/"
              target="_blank"
            >Afriart Gallery</a>
            &nbsp;|&nbsp;{{ new Date().getFullYear('Y') }}&nbsp;|&nbsp;All right reserved
          </div>
        </div>
      </div>
    </div>
    <md-divider />
    <div class="md-layout md-layout-item md-xlarge-size-25 md-large-size-20 md-medium-size-25 md-small-size-70">
      <div class="md-layout md-alignment-center-right">
        <div class="kabs-social">
          <a
            href="https://twitter.com/kampalabiennale?lang=en"
            target="_blank"
          >
            <img
              alt="kab logo"
              width="24"
              height="24"
              :src="require('@/assets/sm-twitter.svg')"
            >
          </a>
          <a
            href="https://web.facebook.com/KampalaArtBiennale"
            target="_blank"
          >
            <img
              alt="kab logo"
              width="24"
              height="24"
              :src="require('@/assets/sm-facebook.svg')"
            >
          </a>
          <a
            href="https://www.instagram.com/kampalaartbiennale/?hl=en"
            target="_blank"
          >
            <img
              alt="kab logo"
              width="24"
              height="24"
              :src="require('@/assets/sm-instagram.svg')"
            >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    accent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.footer-section {
  background-color: $color-primary;
  min-height: 99px;
  &.accent {
    background-color: transparent !important;
  }
  .footer-container {
    margin: auto 13% auto 13%;
  }
  .kabs-logo {
    margin-left: 13%;
    margin-top: 10px;
  }
  .event-sponsor {
    margin-left: 10px;
    margin-bottom: 10px;
    img {
      position: relative;
      top: 5px;
    }
    &:last-child {
      img {
        position: relative;
        top: 8px;
      }
    }
    h1 {
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      color: $color-white;
    }
  }
  a {
    color: $color-white !important;
  }
  .kabs-terms {
    min-height: 15px;
    color: $color-white;
    a {
      font-size: 14px;
      margin-right: 5px;
    }
  }
  .md-divider {
    background-color: #c2d1d9 !important;
  }

  .kabs-social {
    margin-top: 5px;
    margin-right: 25px;
  }
}
@media only screen and (max-width: 600px) {
  .footer-section {
    .kabs-logo {
      margin-left: 10% !important;
    }
    .event-sponsor {
      margin-left: 10px;
    }
  }
}
</style>
